<template>
<div class="chapter">
<div class="inner_page">
      ﻿

 <meta charset="utf-8"/> <link href="styles/default.css" rel="stylesheet" type="text/css"/> <title>Volume One</title>
<div class="chapter">
<div class="box">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Volume One">
<h1 class="txc" id="a_12">
<i>
<a href="#/contents#b_2" id="a_1">Volume <br/> One</a>
</i>
</h1>
<p class="ser">
<a id="page7">
<img alt="" class="maxwidth" id="p0007-d6e20" role="presentation" src="images/978141857365_0007_002.jpg"/>
</a></p><a id="page7">
</a></section><a id="page7">
</a></div><a id="page7">
</a></div>
<a id="page7">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?f79a3a12